





























































































import { Component, Vue } from "vue-property-decorator";
import kostl from "@/apis/kostl/$api";
import aspida from "@aspida/axios";
import { UnyoList, UnyoPost } from "@/apis/kostl/vehicles/@types";
import moment from "moment";
import { BvTableFieldArray } from "bootstrap-vue";

@Component
export default class PostUnyo extends Vue {
  unyoList: UnyoList = {};
  postList: Omit<UnyoPost, "id">[] = [];
  readonly moment = moment;

  draft = "";

  JapaneseHolidays = require("japanese-holidays");
  get isHoliday(): boolean {
    let date = new Date();
    date.setHours(date.getHours() - 3);
    return (
      date.getDay() == 0 ||
      date.getDay() == 6 ||
      this.JapaneseHolidays.isHolidayAt(date)
    );
  }

  readonly tableFields: BvTableFieldArray = [
    { key: "unyo", label: "運用番号", sortable: true },
    { key: "vehicle", label: "編成番号", sortable: true },
    {
      key: "timestamp",
      label: "投稿日時",
      formatter: this.getStringTime,
      sortable: true
    }
  ];

  mounted() {
    this.fetchData();
  }

  fetchData() {
    kostl(aspida())
      .vehicles.$get()
      .then(data => {
        this.unyoList = Object.assign({}, this.unyoList, data);
        Object.entries(this.unyoList).forEach(([key, value]) => {
          this.postList.push(...value.map(val => ({ unyo: key, ...val })));
        });
      });
  }

  postDraft() {
    const lines = this.draft.split("\n");
    for (const line of lines) {
      let sec = line.split(" ");
      if (
        sec[0].slice(-1) !== "K" &&
        sec[0].slice(-1) !== "T" &&
        sec[0].slice(1) !== "N"
      )
        sec[0] = "No." + sec[0];

      this.postData(sec[0], sec[1]);
    }
    this.draft = "";
  }

  postData(unyo: string, vehicle: string) {
    kostl(aspida()).vehicles.$post({
      body: {
        unyo: unyo,
        vehicle: vehicle
      }
    });
  }

  getPosts(unyo: string): { vehicle: string; created_at: string }[] {
    if (unyo in this.unyoList) {
      if (this.unyoList[unyo].length) {
        return this.unyoList[unyo];
      }
    }
    return [{ vehicle: "-", created_at: "" }];
  }

  get isDraftValid() {
    if (!this.draft) return "none";

    const lineRegExp = /^(No.)?(\d{1,2}|5\S)[KT]?\s\d{3,4}F(\+\d{3,4}F)?$/;
    const lines = this.draft.split("\n");
    for (const line of lines) {
      if (!lineRegExp.test(line)) return false;
    }

    return true;
  }

  getStringTime(timestamp: string) {
    return moment(timestamp).format("MM/DD HH:mm:ss");
  }

  readonly unyoOnly_W = [
    "No.1",
    "No.2",
    "No.3",
    "No.4",
    "No.5",
    "No.6",
    "No.7",
    "No.8",
    "No.9",
    "No.10",
    "No.11",
    "No.12",
    "No.13",
    "No.14",
    "No.15",
    "No.16",
    "No.17",
    "No.20",
    "No.21",
    "No.22",
    "No.23",
    "No.24",
    "No.25",
    "No.26",
    "No.27",
    "No.28",
    "No.29",
    "No.30",
    "No.31",
    "No.32",
    "No.33",
    "No.34",
    "No.40",
    "No.41",
    "No.42",
    "No.43",
    "No.44",
    "No.50",
    "No.52",
    "No.54",
    "No.56",
    "No.58",
    "No.60",
    "No.62",
    "No.64",
    "No.66",
    "No.70",
    "No.72",
    "No.74",
    "No.76",
    "No.80",
    "No.82",
    "No.84",
    "No.86",
    "No.88",
    "51K",
    "53K",
    "55K",
    "57K",
    "5aK",
    "5bK",
    "61K",
    "63K",
    "65K",
    "67K",
    "69K",
    "71K",
    "73K",
    "75K",
    "77K",
    "79K",
    "81K",
    "83K",
    "85K",
    "87K",
    "89K",
    "91K",
    "1T",
    "3T",
    "5T",
    "7T",
    "9T",
    "11T",
    "13T",
    "15T",
    "17T",
    "19T",
    "21T",
    "23T",
    "25T",
    "27T",
    "29T",
    "31T",
    "33T",
    "35T",
    "37T",
    "39T",
    "41T",
    "51T",
    "53T",
    "55T",
    "57T",
    "59T",
    "61T"
  ];

  readonly unyoOnly_H = [
    "No.1",
    "No.2",
    "No.3",
    "No.4",
    "No.5",
    "No.6",
    "No.7",
    "No.8",
    "No.9",
    "No.10",
    "No.11",
    "No.12",
    "No.13",
    "No.14",
    "No.15",
    "No.16",
    "No.17",
    "No.20",
    "No.21",
    "No.22",
    "No.23",
    "No.30",
    "No.31",
    "No.32",
    "No.33",
    "No.34",
    "No.35",
    "No.36",
    "No.40",
    "No.41",
    "No.50",
    "No.52",
    "No.54",
    "No.56",
    "No.58",
    "No.60",
    "No.62",
    "No.70",
    "No.72",
    "No.74",
    "51K",
    "53K",
    "55K",
    "57K",
    "61K",
    "63K",
    "65K",
    "67K",
    "69K",
    "71K",
    "73K",
    "75K",
    "77K",
    "79K",
    "81K",
    "83K",
    "85K",
    "87K",
    "89K",
    "91K",
    "93K",
    "1T",
    "3T",
    "5T",
    "7T",
    "9T",
    "11T",
    "13T",
    "15T",
    "17T",
    "19T",
    "21T",
    "23T",
    "25T",
    "27T",
    "29T",
    "31T",
    "33T",
    "51T",
    "53T",
    "55T"
  ];
}
